<div class="st-page">
  <div class="sh-greeting-row">
    <div>
      <h1 class="sh-greeting">{{ 'goodAfternoon' | translate }}, <span class="sh-greeting-name">{{ staffFirstName }}</span> <span class="sh-wave">👋</span></h1>
      <p class="st-subtitle">{{ 'staffHomeSubtitlePrefix' | translate }} {{ schoolName }} {{ 'staffHomeSubtitleSuffix' | translate }}</p>
    </div>
    <div class="sh-date-chip"><i class="ri-calendar-line"></i> {{ today }}</div>
  </div>

  <div class="sh-stat-grid">
    <div class="sh-stat-card" *ngFor="let s of stats">
      <div class="sh-stat-glow" [ngClass]="'sh-glow-' + s.color"></div>
      <div class="sh-stat-icon" [ngClass]="'sh-icon-' + s.color"><i [ngClass]="s.icon"></i></div>
      <div class="sh-stat-value">{{ s.value }}</div>
      <div class="sh-stat-label">{{ s.label | translate }}</div>
      <div class="sh-stat-trend"><i class="ri-arrow-up-line"></i> {{ s.trend }}</div>
    </div>
  </div>

  <div class="sh-two-col">
    <div class="st-card sh-panel">
      <div class="sh-panel-head">
        <div class="sh-panel-title"><span class="sh-panel-icon sh-icon-blue"><i class="ri-megaphone-line"></i></span> {{ 'recentBroadcasts' | translate }}</div>
        <a class="sh-view-all" routerLink="/staff/broadcast">{{ 'viewAll' | translate }}</a>
      </div>
      <div class="sh-broadcast-row" *ngFor="let b of broadcasts">
        <div class="sh-panel-icon sh-icon-blue"><i class="ri-megaphone-line"></i></div>
        <div class="st-list-text">
          <div class="st-list-title">{{ b.title }}</div>
          <div class="st-list-sub">{{ b.preview }}</div>
          <div class="sh-broadcast-meta">
            <span class="st-chip st-chip-grey">{{ b.audience }}</span>
            <span class="sh-time">{{ b.time }}</span>
          </div>
        </div>
        <div class="sh-broadcast-percent">
          <div class="sh-percent-value">{{ b.readPercent }}%</div>
          <div class="sd-progress-track"><div class="sd-progress-fill sd-accent-blue" [style.width.%]="b.readPercent"></div></div>
        </div>
      </div>
    </div>

    <div class="st-card sh-panel">
      <div class="sh-panel-head">
        <div class="sh-panel-title"><span class="sh-panel-icon sh-icon-green"><i class="ri-notification-3-line"></i></span> {{ 'notifications' | translate }}</div>
        <span class="st-chip st-chip-blue">{{ notifications.length }} {{ 'new' | translate }}</span>
      </div>
      <div class="sh-notif-row" *ngFor="let n of notifications">
        <span class="sh-notif-dot" [class.unread]="n.unread"></span>
        <div class="st-list-text">
          <div class="st-list-title">{{ n.text }}</div>
          <div class="st-list-sub">{{ n.time }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="sh-two-col">
    <div class="st-card sh-panel">
      <div class="sh-panel-head">
        <div class="sh-panel-title"><span class="sh-panel-icon sh-icon-purple"><i class="ri-chat-3-line"></i></span> {{ 'messages' | translate }}</div>
        <a class="sh-view-all" (click)="openChat()">{{ 'openChat' | translate }}</a>
      </div>
      <div class="sh-msg-row" *ngFor="let m of messages">
        <div class="st-avatar" [ngClass]="'sh-icon-' + m.color">{{ m.initials }}</div>
        <div class="st-list-text">
          <div class="st-list-title">{{ m.name }}</div>
          <div class="st-list-sub">{{ m.preview }}</div>
        </div>
        <div class="sh-msg-meta">
          <span class="sh-time">{{ m.time }}</span>
          <span class="sh-unread-badge" *ngIf="m.unreadCount">{{ m.unreadCount }}</span>
        </div>
      </div>
    </div>

    <div class="st-card sh-panel">
      <div class="sh-panel-head">
        <div class="sh-panel-title"><span class="sh-panel-icon sh-icon-blue"><i class="ri-time-line"></i></span> {{ 'recentActivity' | translate }}</div>
        <a class="sh-view-all">{{ 'viewAll' | translate }}</a>
      </div>
      <div class="sh-activity-row" *ngFor="let a of activity">
        <div class="sh-activity-icon" [ngClass]="'sh-icon-' + a.color"><i [ngClass]="a.icon"></i></div>
        <div class="st-list-text">
          <div class="st-list-title">{{ a.text }}</div>
          <div class="st-list-sub">{{ a.meta }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
